import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';

export const CardDisplay = ({ card, state, outerRef, innerRef, CardComponent }) => {
  const innerStyles = useMemo(
    () => ({
      idle: {
        cursor: 'grab',
      },
      'is-dragging': {
        opacity: 0.4,
      },
    }),
    [],
  );

  const outerStyles = useMemo(
    () => ({
      // We no longer render the draggable item after we have left it
      // as it's space will be taken up by a shadow on adjacent items.
      // Using `display:none` rather than returning `null` so we can always
      // return refs from this component.
      // Keeping the refs allows us to continue to receive events during the drag.
      'is-dragging-and-left-self': {
        // display: 'none',
        opacity: 0.4,
      },
    }),
    [],
  );

  return (
    <Box
      ref={outerRef}
      pb="8px"
      className="board-card"
      sx={{
        display: 'flex',
        flexShrink: 0,
        flexDirection: 'column',
        gap: '8px',
        ...outerStyles[state.type],
      }}
    >
      {/* Put a shadow before the item if closer to the top edge */}
      {/* state.type === 'is-over' && state.closestEdge === 'top' ? <CardShadow dragging={state.dragging} /> : null */}
      <CardComponent card={card} state={state} innerRef={innerRef} innerStyles={innerStyles} />
      {/* Put a shadow after the item if closer to the bottom edge */}
      {/* {state.type === 'is-over' && state.closestEdge === 'bottom' ? <CardShadow dragging={state.dragging} /> : null} */}
    </Box>
  );
};

CardDisplay.propTypes = {
  card: PropTypes.object.isRequired,
  state: PropTypes.shape({
    type: PropTypes.oneOf(['idle', 'is-dragging', 'is-dragging-and-left-self', 'preview', 'is-over']).isRequired,
    dragging: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    closestEdge: PropTypes.oneOf(['top', 'bottom']),
    container: PropTypes.object,
  }).isRequired,
  outerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
  CardComponent: PropTypes.func.isRequired,
};

CardDisplay.defaultProps = {
  outerRef: null,
  innerRef: null,
};
